// CardImageGallery.tsx
import * as React from 'react';
import { GuitarServiceGallery } from '../services/GuitarServiceGalleriesServiceProvider';
import { CustomShopGallery } from '../services/CustomShopGalleriesServiceProvider';
import { GalleryImage } from '../types/galleryImage';
import { PageProps } from '../types/navigationProperties';
import { Grid, Typography, Tooltip, Card, CardMedia, CardContent, Divider, Zoom as M_ZOOM } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Lightbox from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import { LightShot } from '../components/LightShot';

export default function CardImageGallery({props, pageProps}: {props: GuitarServiceGallery[] | CustomShopGallery[] | undefined, pageProps: PageProps}) {

    const isGuitarService: boolean = props !== undefined ? props.every(key => 'guitar_service_gallery_images' in key) : false;
    const { t } = useTranslation();
    const slideshowDelay: number = 3000;
    const fadeDelay: number = 300;
    const swipeDelay: number = 300;
    const zoomDelay: number = 300;

    const [open, setOpen] = React.useState(false);
    const [index, setIndex] = React.useState(0);
    const [selectedImages, setSelectedImages] = React.useState<GalleryImage[]>();

    const toggleOpen = (state: boolean) => () => setOpen(state);

    const updateIndex =  (when: boolean) => ({ index: current }: { index: number }) => {
        if (when === open) {
            setIndex(current);
        }
    };

    const handleOpenLightShot = (items: GalleryImage[]) => {
        setSelectedImages(items);
        toggleOpen(true);
    }

    const getPreviewSlides = (items: GalleryImage[]) => {
        let slides = [...items];
        if(slides.length > 0) {
            return slides.slice(0, 3);
        }
        return slides;
    }

    return (
        <Grid container spacing={2}>
            <LightShot images={selectedImages} opened={open} setOpenLightShot={setOpen} />
            {props !== undefined && props.map((item: any, index: number) => (
                <Grid size={{ xs: 12, sm: 12, md: props.length > 1 ? 6 : 12 }} key={item.slug} sx={{ width: '100%'}}>
                    <Tooltip title={t("open.gallery") + " - " + item.title.value}
                             placement="top"
                             slots={{
                                transition: M_ZOOM,
                             }}
                             slotProps={{
                                transition: { timeout: 300 },
                             }} arrow>
                        <Card sx={{ backgroundColor: 'rgb(255, 255, 255)', '&:hover': { cursor: 'pointer' } }}
                              onClick={((event) => handleOpenLightShot(isGuitarService ? item.guitar_service_gallery_images : item.custom_shop_gallery_images))} >
                            <CardMedia sx={{ height: 200 }}>
                            <Lightbox index={index}
                                    slides={getPreviewSlides(isGuitarService ? item.guitar_service_gallery_images : item.custom_shop_gallery_images)}
                                    plugins={[Inline, Slideshow]}
                                    on={{
                                        view: updateIndex(false),
                                        click: toggleOpen(true),
                                    }}
                                    slideshow={{
                                        autoplay: true,
                                        delay: slideshowDelay
                                    }}
                                    carousel={{
                                        padding: 0,
                                        spacing: 0,
                                        imageFit: "cover",
                                    }}
                                    animation={{
                                        fade: fadeDelay,
                                        swipe: swipeDelay,
                                        zoom: zoomDelay
                                    }}
                                    inline={{
                                        style: {
                                            width: "100%",
                                            height: '200px',
                                            aspectRatio: "3 / 2",
                                            margin: "0 auto",
                                        },
                                    }} />
                            </CardMedia>
                            <Divider sx={{ my: 2, marginTop: '50px', borderColor: 'rgb(0, 0, 0)' }} />
                            <CardContent>
                                <Typography gutterBottom>
                                    { item.title.value ? item.title.value.toUpperCase() : '' }
                                </Typography>
                                <Typography color="textSecondary" component="p">
                                    { item.description.value }
                                </Typography>
                            </CardContent>
                        </Card>
                    </Tooltip>
                </Grid>
            ))}
        </Grid>
    )
}

